import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { MailExpiryReminder as MailExpiryBannerType } from './view.tsx';

const LazyMailExpiryBanner = lazyAfterPaint<typeof MailExpiryBannerType>(() =>
	import(/* webpackChunkName: "async-mail-expiry-banner" */ './view').then(
		({ MailExpiryReminder }) => MailExpiryReminder,
	),
);

export const MailExpiryBannerAsync = () => (
	<JSErrorBoundary
		id="async-mail-expiry-banner"
		packageName="jiraPlatformUiMailExpiryReminder"
		fallback="flag"
	>
		<Placeholder name="async-mail-expiry-banner" fallback={null}>
			<LazyMailExpiryBanner />
		</Placeholder>
	</JSErrorBoundary>
);
